import { getDefaultStatisticItem, getTeamLabelByNumber } from '../../utils/utils'
import { cloneDeep } from '../../../../../utils/utils'

const statisticTemp = [
  {
    'SCORE_INNING': {
      home: 0,
      away: 0
    },
    'SCORE': {
      home: 0,
      away: 0
    },
    'SCORE_IN_ROW': {
      home: 0,
      away: 0
    },
    gamePeriod: 1,
    currentPointStreak: 0,
    currentSide: 0
  }
]

export default {
  statisticScheme: { 
    'SCORE_INNING': getDefaultStatisticItem('trader.badminton.score.inning'),
    'SCORE': getDefaultStatisticItem('trader.badminton.score'),
    'SCORE_IN_ROW': getDefaultStatisticItem('trader.badminton.score.in.row')
  },
  statisticEvents: {},
  statisticOrder: [
    'SCORE_INNING',
    'SCORE',
    'SCORE_IN_ROW'
  ],
  statisticFunction (event) {
    if (!['POINT', 'CANCEL'].includes(event.EventCode)) {
      return
    }

    const { getActiveSide } = this
    const { TeamNumber, GamePeriod } = event

    if (event.EventCode === 'CANCEL') {
      goToPrevStatisticSnapshot.bind(this)()

      return
    }

    const statisticTempItem = cloneDeep(statisticTemp[statisticTemp.length - 1])

    statisticTempItem.gamePeriod = GamePeriod

    if (!statisticTempItem.currentSide) {
      statisticTempItem.currentSide = TeamNumber
    }

    const currentTeamLabel = getTeamLabelByNumber(TeamNumber)

    if (statisticTempItem.currentSide === TeamNumber && statisticTempItem.currentPointStreak === statisticTempItem['SCORE_IN_ROW'][currentTeamLabel]) {
      statisticTempItem.currentPointStreak++
      statisticTempItem['SCORE_IN_ROW'][currentTeamLabel]++

      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'SCORE_IN_ROW',
        period: GamePeriod,
        team: currentTeamLabel,
        value: statisticTempItem.currentPointStreak
      })
    } else if (statisticTempItem.currentSide === TeamNumber) {
      statisticTempItem.currentPointStreak++
    } else if (statisticTempItem.currentSide !== TeamNumber) {
      statisticTempItem.currentPointStreak = 1
      statisticTempItem.currentSide = TeamNumber

      if (!statisticTempItem['SCORE_IN_ROW'][currentTeamLabel]) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'SCORE_IN_ROW',
          period: GamePeriod,
          team: currentTeamLabel,
          value: statisticTempItem.currentPointStreak
        })
      }
    }

    if (currentTeamLabel === getActiveSide) {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'SCORE_INNING',
        period: GamePeriod,
        team: currentTeamLabel,
        type: 'increment',
        value: 1
      })

      statisticTempItem['SCORE_INNING'][currentTeamLabel]++

      statisticTemp.push(statisticTempItem)
    } else {
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'SCORE',
        period: GamePeriod,
        team: currentTeamLabel,
        type: 'increment',
        value: 1
      })

      statisticTempItem['SCORE'][currentTeamLabel]++

      statisticTemp.push(statisticTempItem)
    }
  }
}

function goToPrevStatisticSnapshot () {
  const statisticSnapshot = statisticTemp.length > 1 ? statisticTemp[statisticTemp.length - 2] : null

  if (statisticTemp.length > 1) {
    statisticTemp.pop()
  }

  if (!statisticSnapshot || !statisticSnapshot.gamePeriod) {
    return
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE_INNING',
    period: statisticSnapshot.gamePeriod,
    team: 'home',
    value: statisticSnapshot['SCORE_INNING'].home
  })
  
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE_INNING',
    period: statisticSnapshot.gamePeriod,
    team: 'away',
    value: statisticSnapshot['SCORE_INNING'].away
  })
  
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE',
    period: statisticSnapshot.gamePeriod,
    team: 'home',
    value: statisticSnapshot['SCORE'].home
  })

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE',
    period: statisticSnapshot.gamePeriod,
    team: 'away',
    value: statisticSnapshot['SCORE'].away
  })
  
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE_IN_ROW',
    period: statisticSnapshot.gamePeriod,
    team: 'home',
    value: statisticSnapshot['SCORE_IN_ROW'].home
  })

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE_IN_ROW',
    period: statisticSnapshot.gamePeriod,
    team: 'away',
    value: statisticSnapshot['SCORE_IN_ROW'].away
  })
}